/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useMeetingEvent } from "amazon-chime-sdk-component-library-react";
import { useEffect } from "react";
import { useVideoMeetingEvents } from "../VideoMeetingEventProvider";

/**
 * This hook will takes care of ending the meeting when remote attendee disconnected from the meeting unexpectedly.
 */
const useRemoteSession = () => {
	const eventController = useMeetingEvent();
	const { setInMeetingContactId, sendMessage } = useVideoMeetingEvents();

	useEffect(() => {
		if (!eventController) {
			return;
		}
		const checkMeetingState = async () => {
			if (eventController.name === "meetingEnded" || eventController.name === "meetingFailed") {
				setInMeetingContactId("");
			}
		};
		checkMeetingState();
	}, [eventController, sendMessage, setInMeetingContactId]);
};

export default useRemoteSession;
